module.exports = "\n<div class=\"contain\">\n  <div class=\"column\" *ngFor=\"let paragraph of paragraphs | async; let i = index\">\n    <div  [ngClass]=\"{ left: i === 0, middle: i === 1, right: i === 2 }\" [innerHTML]=\"paragraph.content\">\n\n    </div>\n  </div>\n\n\n  <div class=\"picture\">\n    <img src=\"../../../assets/images/moleimage.png\" class=\"image\">\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/body/body.component.html
// module id = ./src/app/components/body/body.component.html
// module chunks = main